import type { ComponentPropsWithoutRef } from "react";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface TokenTypeButtonProps extends ComponentPropsWithoutRef<"button"> {
  tokenType: {
    label: string;
    value: string;
  };
}

export const TokenTypeButton = ({
  tokenType,
  ...props
}: TokenTypeButtonProps) => (
  <button
    type="button"
    className="border-primary group flex w-full items-center justify-between border-b py-4 transition-colors duration-150 ease-in first:!pt-0 last:border-none"
    {...props}
  >
    <Typography.LabelSm weight="semibold">{tokenType.label}</Typography.LabelSm>
    <Icon
      type="16-chevron-right"
      size={16}
      className="text-default group-hover:text-dark"
    />
  </button>
);
